import ImageDetail from 'Pages/auto/images/detail/home'

export default ImageDetail
